import React from 'react';
import { Card, Flex, Text, TruncatedText } from '@chatsdet/ui';
import { ArrowsClockwise, Warning } from '@phosphor-icons/react';
import type { FailedAttemptSummary } from '../../features/workflows/useTestRunDetail';
import { API_URL } from '../../config';

type FlakyAttemptCardProps = {
  failedAttempt: FailedAttemptSummary;
};

export const FlakyAttemptCard: React.FC<FlakyAttemptCardProps> = ({ failedAttempt }) => {
  const screenshotUrl = failedAttempt.failureScreenshotS3Key
    ? `${API_URL}/screenshots/${encodeURIComponent(failedAttempt.failureScreenshotS3Key)}`
    : null;

  return (
    <Card
      variant="bordered"
      padding="md"
      className="border-status-flaky/50 bg-status-flaky/5"
    >
      <Flex align="start" gap="md">
        <div className="flex-1 min-w-0">
          <Flex align="center" gap="sm" className="mb-2">
            <ArrowsClockwise size={20} weight="fill" className="text-status-flaky shrink-0" />
            <Text size="sm" weight="semibold" className="text-status-flaky">
              Passed on retry (flaky)
            </Text>
          </Flex>

          {failedAttempt.failedNodeName && (
            <Flex align="center" gap="xs" className="mb-1">
              <Warning size={14} className="text-muted-foreground shrink-0" />
              <Text size="sm" weight="medium">
                Failed at: {failedAttempt.failedNodeName}
              </Text>
            </Flex>
          )}

          {failedAttempt.errorMessage && (
            <TruncatedText text={failedAttempt.errorMessage} lines={3} className="text-sm text-muted-foreground" />
          )}
        </div>

        {screenshotUrl && (
          <div className="shrink-0 w-48 rounded-md overflow-hidden border border-border">
            <img
              src={screenshotUrl}
              alt="Failure screenshot"
              className="w-full h-auto"
              loading="lazy"
            />
          </div>
        )}
      </Flex>
    </Card>
  );
};
